<main id="main" class="access-data main__offset-header">
  <section>
    <div class="container">
      <h1>Access Data</h1>
      <div class="row">
        <p class="col-12 col-xl-9 col-xxl-7">
          Please select the datasets you want, and then review and accept the
          <button type="button" (click)="openLicenseTermsModal()" class="btn btn-link p-0">
            licence terms
          </button>
          and enter your e-mail address. We will send you a download link and/or instructions for
          connecting to the service.
        </p>
        <p class="mb-sm-5 col-12 col-xl-9 col-xxl-7">
          If you have any queries, please go to our
          <a routerLink="/frequently-asked-questions">FAQ's</a>
        </p>
      </div>
    </div>
  </section>
  <form
    [attr.autocomplete]="'off'"
    [formGroup]="form"
    (ngSubmit)="submit()"
    class="needs-validation"
    novalidate
    *ngIf="!loading; else loader"
  >
    <!-- dummy hidden field to steal country autofill (Chromium-based browsers like Google Chrome, Microsoft Edge, etc) -->
    <input
      type="text"
      name="country"
      autocomplete="country"
      style="position:absolute;
      top:-9999px;
      left:-9999px;
      width:0;
      height:0;
      border:0;
      padding:0;"
    />

    <section class="container">
      <ul class="list-unstyled row datasets__list" formArrayName="requestedServices">
        <li
          *ngFor="let dataset of datasets; let i = index"
          class="col-12 col-sm-6 col-lg-4 col-xxl-3 mb-3"
          [formGroupName]="i"
        >
          <div class="card justify-content-between align-items-center h-100">
            <div class="row g-0 w-100 h-100 justify-content-between">
              <div class="col-3">
                <img
                  src="../../assets/els/images/datasets/portrait/{{
                    dataset.mapServiceURLSlug
                  }}.jpg"
                  srcset="
                    ../../assets/els/images/datasets/portrait/{{dataset.mapServiceURLSlug}}@2x.jpg 2x
                  "
                  class="img-fluid h-100"
                  alt="{{ dataset.name }}"
                />
              </div>
              <div class="col-9 d-flex flex-column justify-content-between">
                <div class="card-body">
                  <h3 class="card-title">{{ dataset.name }}</h3>
                  <ul class="list-unstyled card-text">
                    <ng-template [ngIf]="dataset.downloads && dataset.downloads.length > 0">
                      <li *ngFor="let download of dataset.downloads">
                        {{ download.name === 'FileGeodatabase' ? 'File GDB' : download.name }}
                        <span *ngIf="dataset.mapServiceURLSlug !== 'hvlsp'; else zipText">- {{ download.size }} zip</span>
                        <ng-template #zipText>
                          <span>(zip)</span>
                        </ng-template>
                      </li>
                    </ng-template>
                    <li class="protocol">
                      <span *ngIf="dataset.supportsWFS">WFS</span>
                      <span *ngIf="dataset.supportsWMS">WMS</span>
                      <span *ngIf="dataset.supportsWMTS">WMTS</span>
                    </li>
                    <li *ngIf="dataset.mapServiceMetadata?.lastUpdated">
                      Last Update: {{ dataset.mapServiceMetadata.lastUpdated }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between card-footer" formGroupName="serviceType">
              <div
                *ngIf="dataset.supportsDownload || dataset.mapServiceURLSlug === 'hvlsp'"
                class="form-check d-flex flex-grow-1 align-items-center"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="{{ dataset.mapServiceURLSlug }}-Download"
                  formControlName="DOWNLOAD"
                  (change)="isHvlspDownloadChecked(dataset.id, dataset.mapServiceURLSlug)"
                />
                <label class="form-check-label" for="{{ dataset.mapServiceURLSlug }}-Download">
                  <span class="sr-only">{{ dataset.name }}</span>
                  Download
                </label>
              </div>
              <div
                *ngIf="dataset.supportsWFS || dataset.supportsWMS || dataset.supportsWMTS"
                class="form-check d-flex flex-grow-1 align-items-center"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="{{ dataset.mapServiceURLSlug }}-Webservice"
                  formControlName="MAPSERVICE"
                />
                <label class="form-check-label" for="{{ dataset.mapServiceURLSlug }}-Webservice"
                  ><span class="sr-only">{{ dataset.name }}</span
                  >Web Service</label
                >
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <ng-container *ngIf="showHvlspDownload" [ngTemplateOutlet]="hvlspDownload"></ng-container>
    <section class="form-footer bg-gray py-4 py-sm-5">
      <div [ngSwitch]="true" class="container">
        <ng-container *ngSwitchCase="submitting" [ngTemplateOutlet]="loader"></ng-container>
        <div *ngSwitchCase="submitIsSuccess" class="row justify-content-between align-items-center">
          <div class="d-flex align-items-center col mb-2 mt-2">
            <div class="col-2 fs-4"><i class="bi bi-check-circle"></i></div>
            <div class="col fs-3">
              <p class="m-0">Form has been successfully submitted</p>
              <p class="m-0">Please check your email</p>
            </div>
          </div>
          <div class="col-md-2 col-sm-12 d-flex justify-content-end mb-2 mt-2">
            <button type="button" class="btn btn-secondary" (click)="resetForm()">
              Close <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div *ngSwitchCase="submitIsFailure" class="row justify-content-between align-items-center">
          <div class="d-flex align-items-center col mb-2 mt-2">
            <div class="col-2 fs-4"><i class="bi bi-exclamation-circle"></i></div>
            <div class="col fs-3">
              <p class="m-0">Sorry, something has gone wrong with the form submission.</p>
              <p class="m-0">Please try again later or <a routerLink="/contact">contact us</a>.</p>
            </div>
          </div>
          <div class="col-md-2 col-sm-12 d-flex justify-content-end mb-2 mt-2">
            <button type="button" class="btn btn-secondary" (click)="resetForm()">
              Close <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div *ngSwitchDefault class="row">
          <div class="col-12 col-sm-6 col-lg-8 col-xxl-6">
            <div class="row">
              <div class="col-12 col-lg-6 col-xxl-12">
                <div class="input-group">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="licenseTerms"
                      formControlName="licenseTerms"
                      [ngClass]="{ 'is-invalid': licenseTermsIsInvalid() }"
                      required
                    />
                    <label class="form-check-label" for="licenseTerms"> </label>
                    I agree to the
                    <button
                      type="button"
                      class="btn btn-link p-0"
                      (click)="openLicenseTermsModal()"
                    >
                      licence terms
                    </button>
                    <span class="required-asterisk">*</span>
                    <div *ngIf="licenseTermsIsInvalid()" class="invalid-feedback">
                      You must accept the licence terms to proceed
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-xxl-12">
                <div class="input-group">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="newsAndUpdates"
                      formControlName="marketingConsent"
                    />
                    <label class="form-check-label" for="newsAndUpdates"
                      >Keep me informed with news and data updates.</label
                    >
                  </div>
                </div>
                <button type="button" (click)="openPrivacyModal()" class="btn btn-link p-0">
                  View our privacy policy
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <label class="form-check-label" for="email"
              >E-mail address <span class="required-asterisk">*</span></label
            >
            <div class="input-group">
              <input
                class="form-control"
                type="email"
                id="email"
                name="emailAddress"
                formControlName="emailAddress"
                [ngClass]="{ 'is-invalid': emailIsInvalid() }"
                [attr.autocomplete]="'off'"
                required
              />
              <span class="d-inline-block" tabindex="0" placement="top"
                    [ngbTooltip]="getTooltipText()"
                    tooltipClass="hvlsp-download-btn custom-tooltip">
                <button class="btn btn-secondary"
                        [disabled]="showHvlspDownload ? !formIsValid() || !hvlspDownloadIsValid() : !formIsValid()">
                  Submit
                  <i class="bi bi-chevron-right"></i>
                </button>
              </span>
              <div *ngIf="emailIsInvalid()" class="invalid-feedback">
                Please enter a valid e-mail address.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</main>
<app-footer [showBackToTop]="false"></app-footer>

<ng-template #loader>
  <section class="container py-5">
    <div class="alert alert-primary d-flex align-items-center justify-content-center" role="alert">
      <div class="spinner-border me-3" role="status"></div>
      Loading...
    </div>
  </section>
</ng-template>

<ng-template #hvlspDownload>
  <section [@toggleHvlspDownloadSection] class="hvlsp-download-container">
    <div #targetElementToScroll class="container py-5">
      <h2 class="title mb-3">High-value large-scale pan European prototype Download</h2>
      <div class="row gap-5">
        <div class="col-md gap-4">
          <h5 class="sub-title">1. Select your Theme(s)</h5>
          <div class="d-flex flex-column gap-2">
            <div
              class="form-check d-flex flex-grow-1 align-items-center"
              *ngFor="let theme of themeList"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [id]="theme.trim().toLowerCase().replace(' ', '-')"
                [name]="theme.trim().toLowerCase().replace(' ', '-')"
                [value]="theme.trim().toLowerCase().replace(' ', '-')"
                (change)="onSelectChange('checkbox', $event, theme)"
              />
              <label class="form-check-label ms-3" [for]="theme.trim().toLowerCase().replace(' ', '-')">
                <span class="sr-only">{{ theme }}</span>
                {{ theme }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md gap-4">
          <h5 class="sub-title">
            2. Select your Area(s)
            <button type="button" class="btn ms-2 p-0" placement="top"
                    ngbTooltip="You can choose between any one of the below. You can add multiple options in a selection."
                    tooltipClass="custom-tooltip">
              <span
                class="bi bi-info-circle"
              ></span>
            </button>
          </h5>
          <div
            class="d-flex flex-grow-1 flex-column align-items-start gap-4"
          >
            <div class="d-flex align-items-center w-100">
              <input class="form-check-input radio mt-0" type="radio" name="selectAreaRadioOptions"
                     id="download-for-all-countries-radio" value="1"
                     (change)="onSelectChange('radio', $event)" [(ngModel)]="selectAreaRadioValue">
              <label class="form-check-label w-100 ms-2" for="download-for-all-countries-radio">
                Download for all Countries
              </label>
            </div>
            <div class="d-flex flex-column gap-4 w-100">
              <div class="divider">
                <span class="text">OR</span>
              </div>
              <div class="d-flex align-items-center w-100">
                <input class="form-check-input radio mt-0" type="radio" name="selectAreaRadioOptions"
                       id="select-by-country-radio" value="2" (change)="onSelectChange('radio', $event)"
                       [(ngModel)]="selectAreaRadioValue">
                <div class="d-flex flex-column w-100 ms-2">
                  <label for="select-by-country" class="ms-2">Select by Country</label>
                  <tag-input id="select-by-country" class="tag-input w-100 ms-2" [(ngModel)]="countrySelectList"
                             [onlyFromAutocomplete]="true"
                             placeholder="Select"
                             secondaryPlaceholder="Select"
                             [animationDuration]="{enter: '50ms', leave: '50ms'}"
                             [ripple]="false"
                             (onFocus)="onCountrySelectInputFocus('focus')"
                             (onBlur)="onInputBlur()"
                             (onAdd)="onCountrySelectInputFocus('add')"
                             (onRemove)="onCountrySelectInputFocus('remove')"
                             (onTextChange)="updateCountryOnAutoFill($event)"
                             [inputText]="initialTextForCountrySelect">
                    <tag-input-dropdown
                      class="tag-input-dropdown"
                      [showDropdownIfEmpty]="isInputFocused" [keepOpen]="true"
                      [autocompleteObservable]="dropdownItemsForCountry"
                      [appendToBody]="false"
                    >
                    </tag-input-dropdown>
                  </tag-input>
                </div>
              </div>
              <div class="divider">
                <span class="text">OR</span>
              </div>
            </div>
            <ngb-alert
              class="d-flex justify-content-start align-items-start alert alert-primary"
              type="info"
              [dismissible]="false"
              *ngIf="selectAreaRadioValue == 3 && administrativeAreaSelectList.length === 0"
              (close)="administrativeAreaSelectList.length > 0"
            >
              <i class="bi bi-info-circle icon"></i> To view Administrative Units for one country only, please type in
              the country name first.
            </ngb-alert>
            <div class="d-flex align-items-center w-100">
              <input class="form-check-input radio mt-0" type="radio" name="selectAreaRadioOptions"
                     id="select-by-administrative-area-radio" value="3"
                     (change)="onSelectChange('radio', $event)" [(ngModel)]="selectAreaRadioValue">
              <div class="d-flex flex-column w-100 ms-2">
                <label for="select-by-administrative-area" class="ms-2">Select by Administrative Units (Level 2)</label>
                <tag-input id="select-by-administrative-area" class="tag-input w-100 ms-2"
                           [(ngModel)]="administrativeAreaSelectList"
                           [onlyFromAutocomplete]="true"
                           placeholder="Select"
                           secondaryPlaceholder="Select"
                           [animationDuration]="{enter: '50ms', leave: '50ms'}"
                           [ripple]="false"
                           (onFocus)="onAdministrativeAreaSelectInputFocus('focus')"
                           (onBlur)="onInputBlur()"
                           (onAdd)="onAdministrativeAreaSelectInputFocus('add')"
                           (onRemove)="onAdministrativeAreaSelectInputFocus('remove')"
                           (onTextChange)="updateAdministrativeAreaOnAutoFill($event)"
                           [inputText]="initialTextForAdministrativeAreaSelect">
                  <tag-input-dropdown
                    class="tag-input-dropdown"
                    [showDropdownIfEmpty]="true" [keepOpen]="true"
                    [autocompleteObservable]="dropdownItemsForAdministrativeArea"
                    [appendToBody]="false"
                  >
                  </tag-input-dropdown>
                </tag-input>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 gap-4" *ngIf="mapServiceData.mapServiceDownloadList.length > 0">
          <h5 class="sub-title">Download File Size(s)</h5>
          <div class="alert alert-primary d-flex align-items-center justify-content-center" role="alert" *ngIf="mapsServiceDownloadDataLoading; else mapServiceDownloadError;">
            <div class="spinner-border me-3" role="status"></div>
            Loading...
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-template>

<ng-template #mapServiceDownloadError>
  <div class="alert alert-danger d-flex align-items-center justify-content-center" role="alert" *ngIf="mapsServiceDownloadError; else contentTemplate;">
    {{ mapsServiceDownloadErrorText }}
  </div>
</ng-template>

<ng-template #contentTemplate>
  <div class="d-flex flex-column gap-1">
    <label *ngFor="let data of mapServiceData.mapServiceDownloadList">{{ data.name }}: GeoPackage - {{ data.sizeInBytes | bytesConverter }} zip</label>
  </div>
</ng-template>

